export default function Footer() {
  const scrollToSection = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-secondary-700 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="font-heading text-xl font-bold text-background-50 block mb-3">
              国产91视频
            </span>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              糖心视频、黑桃视频、妖精视频、桃花视频等视频APP聚合平台，专注手机看视频移动端播放体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '精选推荐', href: '#media' },
                { label: '热门话题', href: '#topics' },
                { label: '焦点专题', href: '#carousel' },
                { label: '人气榜单', href: '#ranking' },
                { label: '视频推荐', href: '#cards' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                  className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">视频APP</h4>
            <div className="flex flex-col gap-2.5">
              {['糖心视频', '黑桃视频', '妖精视频', '桃花视频', '苹果视频', '榴莲视频'].map((name) => (
                <a
                  key={name}
                  href="#app"
                  onClick={(e) => { e.preventDefault(); scrollToSection('#app'); }}
                  className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                >
                  {name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              更多优质视频APP持续接入中，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/20 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 国产91视频. 本站所有内容仅供展示。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollToSection('#hero'); }} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">回到顶部</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('#about'); }} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">关于平台</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('#contact'); }} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}